<template>
  <div>Marca excluída com <b>Sucesso</b>.</div>
</template>

<script>
  export default {
    name: 'notification-success'
  }
</script>
